import moment from 'moment';
import React from 'react';
import { Avatar, Col, Row } from 'components';
import { GreenDotIcon } from '../icons/GreenDotIcon';
import styles from './styles.module.scss';

interface CommentItemProps {
  comment: any;
  logRef?: (node: Element | null) => void | undefined;
}

export const CommentItem: React.FC<CommentItemProps> = ({ comment, logRef }) => {
  return (
    <Row className={styles.comment_item} ref={logRef}>
      <Col span={4} style={{ paddingTop: 13 }}>
        <Row gutter={8}>
          <Col>
            <GreenDotIcon />
          </Col>
          <Col>{moment(comment.createDate).format('hh:mmA')}</Col>
        </Row>
      </Col>
      <Col span={20}>
        <Row className={styles.collapse_title}>
          <Col span={2}>
            <Avatar src={comment?.user?.files?.AVATAR} size="large" className={styles.avatar}>
              {comment?.user?.firstName?.charAt(0)}
              {comment?.user?.lastName?.charAt(0)}
            </Avatar>
          </Col>
          <Col style={{ paddingTop: 5 }} span={22}>
            <strong>{`${comment?.user?.firstName} ${comment?.user?.lastName}`}</strong>
            <br />
            <span>{comment.message}</span>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
